import { render, staticRenderFns } from "./SchemaSimpleTable.vue?vue&type=template&id=18b25e19&scoped=true&"
import script from "./SchemaSimpleTable.vue?vue&type=script&lang=js&"
export * from "./SchemaSimpleTable.vue?vue&type=script&lang=js&"
import style0 from "./SchemaSimpleTable.vue?vue&type=style&index=0&id=18b25e19&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b25e19",
  null
  
)

export default component.exports